export class Flag {
    flagID: string;
    text: string; //See enviroments for flag type validation (flagValueRestrictions)
    condition: string;
    value: string;
    isDeleted: boolean;
    isNew: boolean;
    isEdited: boolean;
}